import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { api } from "../lib/api";
import { Wrench, AlertTriangle } from "lucide-react";

// Banner pentru șoferii desemnați în Planificator:
// - LUNI: reminder să acceseze Întreținere mașini.
// - DUMINICĂ: alertă roșie dacă mașina lor nu are ulei/antigel/poza km încărcate.
export default function DriverMaintenanceBanner() {
  const navigate = useNavigate();
  const [info, setInfo] = useState(null);

  const day = new Date().getDay();
  const isMonday = day === 1;
  const isSunday = day === 0;

  useEffect(() => {
    if (!isMonday && !isSunday) return;
    api.get("/me/car-maintenance/driver-reminder").then((r) => setInfo(r.data)).catch(() => {});
  }, [isMonday, isSunday]);

  if (!info?.is_driver) return null;

  // DUMINICĂ: alertă roșie per mașină incompletă
  if (isSunday) {
    const carsMissing = info.cars_detail || [];
    if (carsMissing.length === 0) return null;
    return (
      <div
        className="rounded-lg border-2 border-red-500 bg-red-50 p-4 flex items-center justify-between gap-3 flex-wrap"
        data-testid="driver-maintenance-sunday-banner"
      >
        <div className="flex items-start gap-3">
          <div className="w-10 h-10 rounded-md bg-red-600 text-white grid place-items-center shrink-0">
            <AlertTriangle size={20} />
          </div>
          <div>
            <div className="font-bold text-red-900">🔴 Mașina ta nu are toate verificările săptămâna asta!</div>
            <div className="text-xs text-red-800 mt-0.5 space-y-0.5">
              {carsMissing.map((c) => (
                <div key={c.car_id} data-testid={`driver-sunday-car-${c.car_id}`}>
                  🚙 <strong>{[c.car, c.plate].filter(Boolean).join(" · ")}</strong> — lipsă: <strong>{(c.missing || []).join(" + ")}</strong>
                </div>
              ))}
            </div>
          </div>
        </div>
        <button
          onClick={() => navigate("/intretinere-masini")}
          className="px-4 py-2 rounded-md bg-red-600 hover:bg-red-700 text-white font-bold text-sm"
          data-testid="driver-maintenance-sunday-goto-btn"
        >
          Completează acum →
        </button>
      </div>
    );
  }

  // LUNI: reminder standard
  if (!isMonday || info?.completed) return null;

  return (
    <div
      className="rounded-lg border-2 border-teal-500 bg-teal-50 p-4 flex items-center justify-between gap-3 flex-wrap"
      data-testid="driver-maintenance-banner"
    >
      <div className="flex items-start gap-3">
        <div className="w-10 h-10 rounded-md bg-teal-600 text-white grid place-items-center shrink-0">
          <Wrench size={20} />
        </div>
        <div>
          <div className="font-bold text-teal-900">🔔 Ești șofer săptămâna asta — completează ÎNTREȚINERE MAȘINI</div>
          <div className="text-xs text-teal-800 mt-0.5">
            Mașina ta: <strong>{(info.cars || []).join(", ")}</strong>
            {info.missing?.length > 0 && <> · De completat: <strong>{info.missing.join(" + ")}</strong></>}
          </div>
        </div>
      </div>
      <button
        onClick={() => navigate("/intretinere-masini")}
        className="px-4 py-2 rounded-md bg-teal-600 hover:bg-teal-700 text-white font-bold text-sm"
        data-testid="driver-maintenance-goto-btn"
      >
        Deschide Întreținere mașini →
      </button>
    </div>
  );
}
